import React from "react";
import ChannelsView from "../../components/views/channels-view/ChannelsView";

export default function ChannelsPage() {
  return <ChannelsView />;
}
